/*jshint maxcomplexity: 10 */
import ajax from 'static/script/app/data/ajax';
import antiForgeryToken from 'static/script/app/data/anti-forgery-token';
import _ from 'static/script/libs/underscore';
import InitData from 'static/script/app/data/init-data';

let WithAjax = function () {

    this._currentRequests = {};

    this._callSuccessHandler = function (callbackOrEvent, data) {
        if (_.isFunction(callbackOrEvent)) {
            callbackOrEvent(data);
        }
        else if (_.isString(callbackOrEvent)) {
            this.trigger(callbackOrEvent, data);
        }
    };

    this._callErrorHandler = function (callbackOrEvent, data, jqXHR) {
        if (_.isFunction(callbackOrEvent)) {
            callbackOrEvent(data, jqXHR);
        }
        else if (_.isString(callbackOrEvent)) {
            this.trigger(callbackOrEvent, data);
        }
    };

    this._createSuccessHandler = function (callbackOrEvent) {
        if (!callbackOrEvent) {
            return null;
        }

        return function (data) {
            return this._callSuccessHandler(callbackOrEvent, data);
        }.bind(this);
    };

    this._userAborted = function (jqXHR) {
        return jqXHR.statusText === 'abort';
    };

    this._createErrorHandler = function (callbackOrEvent, noShowError) {
        return function (jqXHR, textStatus, errorThrown) {
            if (this._userAborted(jqXHR, errorThrown)) {
                return;
            }

            let data = jqXHR.responseJSON || { message: 'Någonting gick fel. Pröva att ladda om sidan och försök igen.' };
            data = data.responseStatus || data;

            if (data.code === 'XSRF-Error') {
                window.location.href = window.location.href;
                return;
            }

            if (!this.attr.noShowError && !noShowError) {
                this.trigger(document, 'ui:error:show', data);
            }

            this._callErrorHandler(callbackOrEvent, data, jqXHR);
        }.bind(this);
    };

    this._populateOptions = function (options, method) {
        options.dataType = options.dataType || 'json';
        options.requestId = options.requestId || '';
        options.type = method;
        options.traditional = true;
        options.success = this._createSuccessHandler(options.success);
        options.error = this._createErrorHandler(options.error, options.noShowError);

        if (options.type === 'GET') {
            options.timeout = 15000;
        }

        if (!options.cache) {
            options.cache = (options.type === 'GET') ? false : true;
        }

        return options;
    };

    this._jsonRequest = function (options, method) {
        let deferred = $.Deferred(),
            removeFromCurrentRequests = function (requestId) {
                if (_.has(this._currentRequests, requestId)) {
                    delete this._currentRequests[requestId];
                }
            }.bind(this);

        options = this._populateOptions(options, method);

        if (options.type === 'POST') {
            antiForgeryToken.addToAjaxRequest(options);
        }

        let startTime = new Date();

        let jqXHR = ajax(options)
            .done(function (data, textStatus, jqXHR) {
                deferred.resolve(data, textStatus, jqXHR);
            })
            .fail(function (jqXHR, textStatus, errorThrown) {
                let endTime = new Date();
                this._globalErrorHandler(jqXHR, textStatus, errorThrown, options, startTime, endTime);
                deferred.reject(jqXHR, textStatus, errorThrown);

            }.bind(this))
            .always(function () {
                removeFromCurrentRequests(options.requestId);
            });

        if (options.requestId) {
            if (_.has(this._currentRequests, options.requestId)) {
                this._currentRequests[options.requestId].abort();
            }
            this._currentRequests[options.requestId] = jqXHR;
        }

        deferred.fail(function () {
            jqXHR.abort();
        });
        return deferred;
    };

    this._get = function (options) {
        return this._jsonRequest(options, 'GET');
    };

    this._post = function (options) {
        return this._jsonRequest(options, 'POST');
    };

    this._getInitDataForScribe = function () {
        return InitData.getForScribe();
    };

    this._populateScribePayload = function (jqXHR, textStatus, errorThrown, options, startTime, endTime) {
        return {
            eventName: 'js-ajax-error',
            textStatus: textStatus || '',
            errorThrown: errorThrown || '',
            initData: this._getInitDataForScribe() || '',
            status: jqXHR.status || '',
            state: jqXHR.state ? jqXHR.state() : '',
            responseHeaders: jqXHR.getAllResponseHeaders ? jqXHR.getAllResponseHeaders() : '',
            options: options,
            pageUrl: document.location.href,
            referrer: document.referrer,
            startTime: startTime || '',
            endTime: endTime || ''
        };
    };

    this._globalErrorHandler = function (jqXHR, textStatus, errorThrown, options, startTime, endTime) {
        if (this._userAborted(jqXHR, errorThrown) || jqXHR.statusText === 'timeout') {
            return;
        }
        let payload = this._populateScribePayload(jqXHR || {}, textStatus, errorThrown, options || {}, startTime, endTime);
        this.trigger(document, 'data:scribe', payload);
    };

};

export default WithAjax;


// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/app/data/with-ajax.js